import React from 'react'
import PropTypes from "prop-types";
import "./css/modalContentCharacter.css";

const ModalContentCharacter = ({ image, title }) => {
  return (
    <div className="d-flex justify-content-center">
      <div className=" text-center">
        <div className="book-cover-wrapper d-flex justify-content-center align-items-center">
          <img
            src={image}
            alt={title}
            className="size-images-modal-children-hv"
            draggable="false"
          />
        </div>

        <div className="mt-3 mb-4 d-flex justify-content-center">
          <p className="color-text-gris-modal-character-20-hv mb-1">{title}</p>
        </div>
      </div>
    </div>
  )
}

ModalContentCharacter .propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default ModalContentCharacter;